import voltageImage from '../../assets/faq/electric-meter-voltage.png';
import wiringImage from '../../assets/faq/electric-meter-wiring.png';
import burnoutImage from '../../assets/faq/electric-meter-burnout.png';
import rs485Image from '../../assets/faq/electric-meter-rs485.png';

export const faqSections = [
  {
    id: 'electric',
    number: '01',
    shortTitle: '智能电表',
    title: '智能电表常见问题',
    items: [
      {
        title: '电表无显示、设备离线',
        cause: '进线端无供电。',
        solution: '测量进线端交流电压，正常约 230V；无电压时由专业电工排查上级回路。',
        image: voltageImage,
        imageAlt: '使用万用表测量电表进线供电电压的判断标准'
      },
      {
        title: '进线有压，电表仍无显示',
        cause: '进出线接反，断闸后电表失电。',
        solution: '核对表侧接线标识与对应型号接线图，按厂家要求重新接线。',
        image: wiringImage,
        imageAlt: '电表火线与零线正确及错误接线对比示意图'
      },
      {
        title: '电表接线端烧毁',
        cause: '导线虚接、松动，接触点持续发热。',
        solution: '接线时务必查看电表侧面的接线标识，确保导线插入到位、端子牢固且无铜丝外露。',
        judgement: '如果电表从进线端开始烧毁，上半部分相对完好，可作为虚接发热的判断依据。',
        image: burnoutImage,
        imageAlt: '电表进线端烧毁、上半部分相对完好的故障示例'
      },
      {
        title: 'RS485 电表平台离线',
        cause: '通信线松动、氧化或 A/B 极性接反。',
        solution: '重新紧固并核对极性；建议使用 RVSP 屏蔽双绞线降低干扰。',
        image: rs485Image,
        imageAlt: 'RS485 电表 A、B 通信端子位置示意图'
      },
      {
        title: '4G 等无线电表离线',
        cause: '未主动上报，或安装区域信号弱。',
        solution: '长按按键 3～5 秒触发上报；重点测试地下室、配电间及金属箱内信号。'
      },
      {
        title: '多块有线电表同时离线',
        cause: '通信总线短路或断路。',
        solution: '短路用蜂鸣档分段排查；断路重点检查最后在线与第一离线表之间的线路。'
      }
    ]
  },
  {
    id: 'water',
    number: '02',
    shortTitle: '智能水表',
    title: '智能水表常见问题',
    items: [
      { title: '有线水表离线', cause: '接口松动、氧化，或 M-Bus 总线故障。', solution: '重新接线并测量 M-Bus 端口，正常约 DC 36V；异常时分段排查。' },
      { title: '4G／无线水表离线', cause: '未按周期上报，或区域信号覆盖差。', solution: '长按按键或将磁铁置于感应区约 5 秒触发上报，并测试现场信号。' },
      { title: '新装水表显示 99999m³', cause: '安装方向相反，机械指针反向转动。', solution: '确认表体箭头与实际水流方向一致，按正确方向重新安装。' },
      { title: '机械读数与平台不一致', cause: '初始底数错误、部件磨损或电子模块故障。', solution: '核对两端读数；由技术人员红外校准底数，硬件损坏则更换模块或整表。' },
      { title: '无人用水，水表仍走字', cause: '漏水、管道存气、水压波动或回流。', solution: '关闭用水点观察；检查马桶、水龙头，放水约 1 分钟排气，必要时加止回阀。' },
      { title: '水表能否倾斜安装？', cause: '不建议倾斜，可能影响计量精度。', solution: '按 H／V 标识安装并校正流向；直管段遵循进水端 10D、出水端 5D。' }
    ]
  },
  {
    id: 'gateway',
    number: '03',
    shortTitle: '智能网关',
    title: '智能网关常见问题',
    items: [
      { title: '网络灯熄灭、网关离线', cause: '网络中断、网线异常或未获取 IP。', solution: '检查路由器、交换机和网线；同网段使用配置工具查看 IP，必要时设静态 IP。' },
      { title: '网络灯正常，平台仍离线', cause: '服务器地址、端口或账号参数错误。', solution: '核对服务器地址、通信端口、用户名与密码，并刷新服务器连接状态。' },
      { title: '网关在线，无法抄读表计', cause: '下行总线故障或接口电压异常。', solution: '观察 RS485／M-Bus 灯；接口约 DC 4.5V／36V，异常时排查总线与连接。' }
    ]
  }
];
